import styled from "styled-components";

export const NewsPageContainer = styled.main`
  max-width: 920px;
  width: 100%;
  margin: auto;
  padding: 2rem 1rem 4rem;
  min-height: 70vh;
`;
